<div class="offcanvas offcanvas-end" tabindex="-1" id="shoppingCartOffcanvas" aria-labelledby="shoppingCartnvasLabel"
    data-bs-scroll="false" data-bs-backdrop="true">
    <div class="offcanvas-body p-0">
        <div class="header d-flex justify-content-between ">
            <h5 class="offcanvas-title text-uppercase fs-13 fw-b mt-2 pb-2" id="shoppingCartnvasLabel">
                Shopping Cart
            </h5>
            <button type="button" data-bs-dismiss="offcanvas" class="custom-close pb-2" aria-label="Close"
                (click)="closeCartOffcanvas()">
                <img [src]="commonImagePath +'close_btn_sidebar.webp'" alt="Close">
            </button>
        </div>
        <div class=" container border-bottom "></div>
        <div class="shipping">
            <h6 class="mb-0 fw-b fs-13 lh-base " *ngIf="remainingAmount > 0 && orderItemsData?.length > 0 && !isLoading">
                Almost there, add <span class="text-danger">${{remainingAmount.toFixed(2)}}</span> more to get
                <span class="text-danger">FREE SHIPPING!</span>
            </h6>
        </div>
        <div *ngIf="isLoading" class="custom-loader">
            <div class="spinner"></div>
            <p>Loading your cart...</p>
        </div>
        <div class="p-20 text-danger text-center" *ngIf="errorMsg && !isLoading">
            {{ errorMsg || "" }}
        </div>
        <ng-container *ngIf="orderItemsData?.length > 0 && !errorMsg && !isLoading">
            <div class=" ps-1" *ngFor="let item of orderItemsData; let i = index">
                <div class="row p-20">
                    <div class="col-4" data-bs-dismiss="offcanvas" (click)="productRedirection(item.product_key)">
                        <div class="shipping-cart-img">
                            <img [src]="
                    !!item?.product_photo?.small_image &&
                    item?.product_photo?.small_image?.length > 0
                      ? cdnImgPath +
                        item?.product_photo?.small_image
                      : commonImagePath + 'image_not_found.webp' " width="100%" height="auto" alt="cart img"
                                class="img-fluid cursor-pointer" />
                        </div>
                    </div>
                    <div class="col-6 p-1 ">
                        <h6 class="mb-2" data-bs-dismiss="offcanvas" (click)="productRedirection(item.product_key)">
                            <a class="product-title fw-b">{{ item?.product_name || "" }}</a>
                        </h6>
                        <p class="fs-14 text-muted d-flex align-items-center mb-2 gap-2">
                            <del *ngIf="item?.is_promotion_applied == 1">{{ item?.option_price || "" | currency }}</del>
                            <span class=" text-green-p">{{
                                calculated_price[i] || "" | currency
                                }}</span>
                                <del *ngIf="+item?.msrp_price > +calculated_price[i]">
                                    {{ item?.msrp_price | currency }}
                                </del>
                        </p>
                        <b class="saving d-block text-dark mb-3 fw-bold "
                            *ngIf="item?.promotion_key && item?.product_sku !== 'Custom SKU' && item?.is_map_pricing_promo !=='1' && item?.cart_promotion_status !== '1'">
                            My Savings:
                            <span class="color-green fw-bold ">{{
                                (savedAmount[i] * item.qty) || "" | currency
                                }}</span>
                        </b>
                        <div class="quantity fs-14 position-relative">
                            <input type="number" class="input-text text-center" readonly step="1" min="0" max="9999"
                                name="quantity" [value]="item.qty" />
                            <button type="button" class="minus position-absolute start-0 ps-3"
                                [disabled]="item.qty == 1" (click)=" getUpdateCartqty(
                  item.qty - 1,
                  +item.order_key,
                  +item.order_item_key,
                  +item.product_variation_key,
                  +item.final_price
                )">
                                <i class="fa fa-minus"></i>
                            </button>
                            <button type="button" class="plus position-absolute end-0 pe-3" (click)=" getUpdateCartqty(
                  item.qty + 1,
                  +item.order_key,
                  +item.order_item_key,
                  +item.product_variation_key,
                  +item.final_price
                )">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </button>
                        </div>
                        <div class="d-flex align-items-center gap-3 mt-2 pb-3 action-img">
                            <a class="main_link" data-bs-toggle="tooltip" data-bs-placement="top"
                                data-bs-title="Edit this item" routerLink="/cart" data-bs-dismiss="offcanvas"
                                title="Go to cart">
                                <img [src]="commonImagePath+'edit_img.webp'">
                            </a>
                            <a class="main_link" data-bs-toggle="tooltip" title="Remove Item" data-bs-placement="top"
                                data-bs-title="Remove this item" (click)="removeCartItem( +item.order_item_key, 
                                +item.order_key, 
                                +item.product_variation_key,    
                                +item.qty,     
                                +item.price, 
                                +item.final_price, 
                                item.product_name  )">
                                <img [src]="commonImagePath+'delete_img.webp'" class="delete-img" alt="img">
                            </a>
                        </div>
                    </div>
                </div>
                <div class="cart-border"></div>
            </div>
        </ng-container>
        <div class="p-20 text-danger text-center" *ngIf="removeItemMsg">The item has been removed</div>
        <div class="p-20">
            <div *ngIf="orderItemsData?.length > 0 && !errorMsg && !isLoading">
                <div class="d-flex align-items-center  py-2 pt-4">
                    <h5 class="mb-0 flex-grow-1 fs-18 fw-b">Subtotal:</h5>
                    <a class="cart_tot_price fs-18 texrt-reset me-3">{{totalAmount || ""| currency}} </a>
                </div>
                <p class="fs-13 mb-2 ps-0 p-2">
                    Taxes, shipping and discounts codes calculated at checkout.
                </p>
            </div>
            <div class="mt-4 me-4 mb-5 shopping-btns">
                <a *ngIf="orderItemsData?.length > 0 && !isLoggedIn() && !isLoading" [routerLink]="['/checkout']">
                    <button type="button" data-bs-dismiss="offcanvas"
                        class=" btn-info c-blue w-100 text-uppercase mb-3 fw-semibold fs-11">
                        Guest Checkout
                    </button>
                </a>
                <a *ngIf="orderItemsData?.length > 0 && !errorMsg && isLoggedIn()" (click)="getCartVerify()">
                    <button type="button" data-bs-dismiss="offcanvas"
                        class=" btn-info c-blue w-100  text-uppercase fw-semibold fs-11 mb-3">
                        Checkout
                    </button>
                </a>
                <a *ngIf="orderItemsData?.length > 0 && !errorMsg && isLoggedIn()" [routerLink]="['/cart']">
                    <button type="button" class=" btn-info w-100  mb-3 text-uppercase fw-semibold fs-11"
                        data-bs-dismiss="offcanvas">
                        View Cart
                    </button>
                </a>
                <a class="cursor-pointer" (click)="openSocialMediaLoginPopup()" *ngIf="!isLoggedIn() && !isLoading">
                    <button type="button" data-bs-dismiss="offcanvas"
                        class=" btn-info w-100  text-uppercase fw-semibold fs-11">
                        Sign-in
                    </button>
                </a>
            </div>
        </div>
    </div>
</div>